import { DomEvent } from "./DomEvent";
import { Event, EventListener } from "./Event";
import { RepeatItem } from "../components/repeater/RepeatItem";
import { Repeater } from "../components/repeater/Repeater";

export interface RepeatItemDisplayListener extends EventListener<RepeatItemDisplayEvent> {
}

export class RepeatItemDisplayEvent extends Event<RepeatItem> {
    constructor(component: RepeatItem, domEvent?: DomEvent) {
        super(component, domEvent);
    }

    public getRepeatItem(): RepeatItem {
        return this.target;
    }

    public getRepeater(): Repeater {
        return this.getRepeatItem().repeater;
    }
}
